export const categoryDropDownMenu = [
  {
    path: "/admins/categories/new",
    label: "New Category",
    icon: null,
  },
  {
    path: "/admins/categories/",
    label: "All Categories",
    icon: null,
  },
  {
    path: "/admins/categories/?type=roots",
    label: "All Root Categories",
    icon: null,
  },
  {
    path: "/admins/category_groups/",
    label: "Category Groups",
    icon: null,
  },
];

export const productsDropDownMenu = (default_path, user) => [
  {
    path: `${default_path}products/new`,
    label: "New Product",
    icon: null,
    condition: default_path === "/partners/" || user?.current_company,
  },
  { path: `${default_path}products/`, label: "All Products", icon: null },
  {
    path: `${default_path}products/?type=pending`,
    label: "Pending Products",
    icon: null,
  },
  {
    path: `${default_path}products/?type=approved`,
    label: "Approved Products",
    icon: null,
  },
  {
    path: `${default_path}products/?type=featured`,
    label: "Featured Products",
    icon: null,
    condition: default_path === "/admins/",
  },
  {
    path: `${default_path}bulk_updates`,
    label: "Bulk Update",
    icon: null,
    condition: default_path === "/admins/",
  },
];

export const ordersDropMenu = (default_path, orderPath) => [
  {
    path: `${default_path}orders/`,
    label: "All Orders",
    icon: null,
    condition: default_path === "/admins/",
  },
  {
    path: `${default_path}create_order`,
    label: "Create Order",
    icon: null,
    condition: default_path === "/admins/",
  },
  {
    path: `${default_path}orders/?type=PP`,
    label: "Pending Payment",
    icon: null,
    condition: default_path === "/admins/",
  },
  {
    path: `${default_path}orders/?type=PC`,
    label: "Pending Confirmation",
    icon: null,
    condition: default_path === "/admins/",
  },
  {
    path: `${orderPath}?type=PAM`,
    label: "Pending At Merchant",
    icon: null,
  },
  {
    path: `${orderPath}?type=AFP`,
    label: "Available for Pickup",
    icon: null,
  },
  {
    path: `${orderPath}?type=ERPC`,
    label: "En Route to Processing Centre",
    icon: null,
  },
  {
    path: `${orderPath}?type=PPC`,
    label: "At Processing Centre",
    icon: null,
  },
  {
    path: `${orderPath}?type=ECD`,
    label: "En Route to Delivery Centre",
    icon: null,
  },
  {
    path: `${orderPath}?type=ECDA`,
    label: "En Route to Customer Address",
    icon: null,
  },
  { path: `${orderPath}?type=DF`, label: "Delivery Failed", icon: null },
  {
    path: `${orderPath}?type=SD`,
    label: "Successfully Delivered",
    icon: null,
  },
];

export const promotionsDropMenu = (default_path, user) => [
  {
    path: `${default_path}promotions/new`,
    label: "New Promotion",
    icon: null,
    condition: default_path === "/partners/" || user?.current_company,
  },
  {
    path: `${default_path}promotions/`,
    label: "All Promotions",
    icon: null,
  },
  {
    path: `${default_path}promotions/?type=pending`,
    label: "Pending Promotions",
    icon: null,
  },
  {
    path: `${default_path}promotions/?type=approved`,
    label: "Approved Promotions",
    icon: null,
  },
];

export const voucherDropMenu = (default_path) => [
  {
    path: `${default_path}vouchers/new`,
    label: "New Voucher",
    icon: null,
  },
  {
    path: `${default_path}vouchers/`,
    label: "All Vouchers",
    icon: null,
  },
];
export const productConfigurationsDropMenu = [
  {
    path: "/product_configurations/brands",
    label: "Brands",
    icon: null,
  },
  {
    path: "/product_configurations/sizes",
    label: "Sizes",
    icon: null,
  },
  {
    path: "/product_configurations/size_groups",
    label: "Size Group",
    icon: null,
  },
  {
    path: "/product_configurations/colors",
    label: "Colors",
    icon: null,
  },
  {
    path: "/product_configurations/product_tags",
    label: "Tags",
    icon: null,
  },
  {
    path: "/product_configurations/product_taxes",
    label: "Taxes",
    icon: null,
  },
  {
    path: "/product_configurations/countries",
    label: "Countries",
    icon: null,
  },
];

export const deliveryConfigurationsDropMenu = [
  {
    path: "/delivery_configurations/regions",
    label: "Regions",
    icon: null,
  },
  {
    path: "/delivery_configurations/cities",
    label: "Cities",
    icon: null,
  },
  {
    path: "/delivery_configurations/pickup_locations",
    label: "Pickup Locations",
    icon: null,
  },
];

export const appearancesDropMenu = [
  { path: "/appearances/pages", label: "Pages", icon: null },
  {
    path: "/appearances/main_sliders",
    label: "Main Slider",
    icon: null,
  },
  {
    path: "/appearances/category_widgets",
    label: "Category Widgets",
    icon: null,
  },
  {
    path: "/appearances/advert_widgets",
    label: "Advert Widgets",
    icon: null,
  },
];

export const pointsSystemDropMenu = [
  {
    path: "/admins/points_configurations",
    label: "Points Configurations",
    icon: null,
  },
  {
    path: "/admins/points_configurations/points_listing",
    label: "Points Listing Report",
    icon: null,
  },
];

export const reportsDropMenu = [
  {
    path: "/admins/reports/chatbot_analytics",
    label: "Chatbot Analytics",
    icon: null,
  },
  {
    path: "/admins/reports/key_metrics",
    label: "Key Metrics",
    icon: null,
  },
  {
    path: "/admins/reports/sales",
    label: "Sale Report",
    icon: null,
  },
  {
    path: "/admins/reports/subscriber_growth",
    label: "User Growth",
    icon: null,
  },
  {
    path: "/admins/reports/partner_growth",
    label: "Partner Growth",
    icon: null,
  },
  {
    path: "/admins/reports/partner_self_signup_growth",
    label: "Partner Self Sign Up",
    icon: null,
  },
  {
    path: "/admins/reports/sales_per_vendor",
    label: "Sale Per Vendor",
    icon: null,
  },
  {
    path: "/admins/reports/commissions_per_vendor",
    label: "Commissions Per Vendor",
    icon: null,
  },
  {
    path: "/admins/reports/payouts_per_vendor",
    label: "Payout Per Vendor",
    icon: null,
  },
  {
    path: "/admins/reports/top_skus_by_sales",
    label: "Top SKU's by Sales",
    icon: null,
  },
  {
    path: "/admins/reports/top_skus_by_orders",
    label: "Top SKU's by Orders",
    icon: null,
  },
];
